// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"TypeaheadPill__srOnly--2Zxlg","hiddenInput":"TypeaheadPill__hiddenInput--15GV-","root":"TypeaheadPill__root--1klk8","icon":"TypeaheadPill__icon--3mPv4"};